export const APPLICANT_EXPORT_NATIONAL_ID_COLUMN = "National Id";

const NATIONAL_ID_SOURCE_KEYS = [
  APPLICANT_EXPORT_NATIONAL_ID_COLUMN,
  "National ID",
  "national_id",
  "iqama_id",
  "user_identification_id",
];

const NATIONAL_ID_KEY_PATTERN =
  /^(national[\s_-]?id|iqama[\s_-]?id|user_identification_id)$/i;

const isPresentExportValue = (value) =>
  value != null && value !== "" && value !== "-";

const collectNationalIdSources = (row = {}) => {
  if (!row || typeof row !== "object") return [];

  const sources = [row];
  if (row.user && typeof row.user === "object") sources.push(row.user);
  if (row.attributes && typeof row.attributes === "object") {
    sources.push(row.attributes);
  }
  return sources;
};

export const pickExportNationalId = (row = {}) => {
  for (const source of collectNationalIdSources(row)) {
    for (const key of NATIONAL_ID_SOURCE_KEYS) {
      const value = source[key];
      if (isPresentExportValue(value)) {
        return String(value);
      }
    }

    for (const [key, value] of Object.entries(source)) {
      if (!NATIONAL_ID_KEY_PATTERN.test(String(key).trim())) continue;
      if (isPresentExportValue(value)) {
        return String(value);
      }
    }
  }

  return "-";
};

export const normalizeApplicantExportRows = (rows = [], selectedColumns = []) => {
  if (!selectedColumns.includes(APPLICANT_EXPORT_NATIONAL_ID_COLUMN)) {
    return rows;
  }

  return rows.map((row) => {
    const next = { ...row };
    next[APPLICANT_EXPORT_NATIONAL_ID_COLUMN] = pickExportNationalId(row);
    NATIONAL_ID_SOURCE_KEYS.forEach((key) => {
      if (key !== APPLICANT_EXPORT_NATIONAL_ID_COLUMN) {
        delete next[key];
      }
    });
    if (next.user && typeof next.user === "object") {
      NATIONAL_ID_SOURCE_KEYS.forEach((key) => {
        delete next.user[key];
      });
    }
    return next;
  });
};

export const extractApplicantExportRows = (response) => {
  const payload = response?.data;

  if (Array.isArray(payload)) return payload;
  if (Array.isArray(payload?.data)) return payload.data;
  if (Array.isArray(payload?.rows)) return payload.rows;

  return [];
};

export const getApplicantExportCellValue = (header, value) => {
  if (header === APPLICANT_EXPORT_NATIONAL_ID_COLUMN) {
    if (value == null || value === "") return "-";
    return String(value);
  }
  return value ?? "";
};
